import Button from '@shared/components/Button/Button';
import { RoomMember } from 'matrix-js-sdk/src/matrix';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Search } from 'assets/icons/Search.svg';

import InviteWorkspaceMemberItem from './InviteWorkspaceMemberItem';

const INITIAL_DISPLAY_COUNT = 10;
const LOAD_MORE_COUNT = 10;

interface SuggestedMembersFieldProps {
  suggestedMembers: RoomMember[];
  invitees: string[];
  toggleInvitee: (memberId: string) => void;
}

const SuggestedMembersField = ({ suggestedMembers, invitees, toggleInvitee }: SuggestedMembersFieldProps) => {
  const { t } = useTranslation();
  const [visibleCount, setVisibleCount] = useState(INITIAL_DISPLAY_COUNT);

  if (!suggestedMembers.length) {
    return (
      <div className="flex flex-col items-center justify-center py-2 gap-2">
        <Search className="stroke-1.5 h-5 w-5 shrink-0 stroke-black" />
        <span className="text-size-sm text-gray-80">{t('messenger.suggested_members_empty')}</span>
      </div>
    );
  }

  const visibleMembers = suggestedMembers.slice(0, visibleCount);
  const hasMore = visibleCount < suggestedMembers.length;

  return (
    <div className="flex flex-col gap-2">
      {visibleMembers.map((member) => (
        <InviteWorkspaceMemberItem
          key={member.userId}
          name={member.rawDisplayName ?? member.name ?? member.userId}
          isSelected={invitees.includes(member.userId)}
          onClick={() => toggleInvitee(member.userId)}
        />
      ))}
      {hasMore && (
        <Button variant="text" size="md" onClick={() => setVisibleCount((c) => c + LOAD_MORE_COUNT)}>
          {t('show_more')}
        </Button>
      )}
    </div>
  );
};

export default SuggestedMembersField;
